export default "__VITE_ASSET__BPoIhk54__"